/**
 * @generated SignedSource<<ec410755f859be0678864697bc89d7f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DirectoryViewSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "FAVOURITED_DATE_ASC" | "FAVOURITED_DATE_DESC" | "NAME_ASC" | "NAME_DESC";
export type ProjectDirectoryQuery$variables = {
  aaid?: string | null;
  containerId?: string | null;
  favouriteViewsFirst: number;
  favouriteViewsSort?: ReadonlyArray<DirectoryViewSortEnum | null> | null;
  favouriteViewsTql: string;
  includeArchived: boolean;
  workspaceId?: string | null;
  workspaceUuid: string;
};
export type ProjectDirectoryQuery$data = {
  readonly customFieldDefinitionTql: {
    readonly " $fragmentSpreads": FragmentRefs<"buildCustomFieldResolvers">;
  } | null;
  readonly customfieldHeaderSupport: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectDirectoryHeaderColumns">;
  } | null;
  readonly favouriteDirectoryViews: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isDefault: boolean | null;
        readonly uuid: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly hasProjects: {
    readonly hasRecords: boolean;
  } | null;
  readonly reportingLines: {
    readonly managers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly peers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly reports: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
  } | null;
};
export type ProjectDirectoryQuery = {
  response: ProjectDirectoryQuery$data;
  variables: ProjectDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aaid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouriteViewsFirst"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouriteViewsSort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouriteViewsTql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "args": [
    {
      "kind": "Variable",
      "name": "aaidOrHash",
      "variableName": "aaid"
    }
  ],
  "concreteType": "ReportingLines",
  "kind": "LinkedField",
  "name": "reportingLines",
  "plural": false,
  "selections": [
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "managers",
      "plural": true,
      "selections": (v9/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "peers",
      "plural": true,
      "selections": (v9/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "reports",
      "plural": true,
      "selections": (v9/*: any*/)
    }
  ]
},
v11 = {
  "args": [
    {
      "kind": "Variable",
      "name": "includeArchived",
      "variableName": "includeArchived"
    },
    {
      "kind": "Variable",
      "name": "workspaceId",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "HasRecords",
  "kind": "LinkedField",
  "name": "hasProjects",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRecords"
    }
  ]
},
v12 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v13 = [
  {
    "kind": "Literal",
    "name": "q",
    "value": "(entityType = PROJECT AND (type != String OR hasPredefinedValues = true))"
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "kind": "ScalarField",
  "name": "token"
},
v16 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = [
  {
    "kind": "Literal",
    "name": "q",
    "value": "entityType = PROJECT"
  },
  (v12/*: any*/)
],
v19 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "favouriteViewsFirst"
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "favouriteViewsTql"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "favouriteViewsSort"
  },
  (v12/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v21 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v22 = {
  "kind": "ScalarField",
  "name": "id"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v24 = {
  "kind": "ScalarField",
  "name": "type"
},
v25 = [
  (v20/*: any*/),
  (v14/*: any*/),
  (v24/*: any*/)
],
v26 = [
  (v20/*: any*/),
  (v14/*: any*/),
  (v24/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectDirectoryQuery",
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "args": (v13/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "buildCustomFieldResolvers",
            "selections": [
              {
                "concreteType": "CustomFieldDefinitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_userResolver",
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "UserCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_textSelectResolver",
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "TextSelectCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_numberResolver",
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "NumberCustomFieldDefinition"
                      }
                    ]
                  }
                ]
              }
            ],
            "argumentDefinitions": []
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v18/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProjectDirectoryHeaderColumns"
          }
        ]
      },
      {
        "alias": "favouriteDirectoryViews",
        "args": (v19/*: any*/),
        "concreteType": "DirectoryViewConnection",
        "kind": "LinkedField",
        "name": "directoryViewTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "DirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectDirectoryQuery",
    "selections": [
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "args": (v13/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "type": "UserCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "concreteType": "CustomFieldTextAllowedValueConnection",
                        "kind": "LinkedField",
                        "name": "allowedValues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldTextAllowedValueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextAllowedValueNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v22/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "type": "NumberCustomFieldDefinition"
                  },
                  (v23/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v18/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v25/*: any*/),
                    "type": "NumberCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v25/*: any*/),
                    "type": "TextCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v26/*: any*/),
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v26/*: any*/),
                    "type": "UserCustomFieldDefinition"
                  },
                  (v23/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "favouriteDirectoryViews",
        "args": (v19/*: any*/),
        "concreteType": "DirectoryViewConnection",
        "kind": "LinkedField",
        "name": "directoryViewTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "DirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7a76382a7890d9c1864d948cb5ca9868",
    "id": null,
    "metadata": {},
    "name": "ProjectDirectoryQuery",
    "operationKind": "query",
    "text": "query ProjectDirectoryQuery(\n  $aaid: String\n  $workspaceId: ID\n  $workspaceUuid: UUID!\n  $containerId: String\n  $includeArchived: Boolean!\n  $favouriteViewsTql: String!\n  $favouriteViewsFirst: Int!\n  $favouriteViewsSort: [DirectoryViewSortEnum]\n) {\n  reportingLines(aaidOrHash: $aaid) {\n    managers {\n      __typename\n    }\n    peers {\n      __typename\n    }\n    reports {\n      __typename\n    }\n  }\n  hasProjects(includeArchived: $includeArchived, workspaceId: $workspaceId) {\n    hasRecords\n  }\n  customFieldDefinitionTql(q: \"(entityType = PROJECT AND (type != String OR hasPredefinedValues = true))\", workspaceUuid: $workspaceUuid) {\n    ...buildCustomFieldResolvers\n  }\n  customfieldHeaderSupport: customFieldDefinitionTql(q: \"entityType = PROJECT\", workspaceUuid: $workspaceUuid) {\n    ...ProjectDirectoryHeaderColumns\n  }\n  favouriteDirectoryViews: directoryViewTql(q: $favouriteViewsTql, first: $favouriteViewsFirst, workspaceUuid: $workspaceUuid, containerId: $containerId, sort: $favouriteViewsSort) {\n    edges {\n      node {\n        uuid\n        isDefault\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectDirectoryHeaderColumns on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on NumberCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextSelectCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on UserCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on UserCustomFieldDefinition {\n        ...buildCustomFieldResolvers_userResolver\n      }\n      ... on TextSelectCustomFieldDefinition {\n        ...buildCustomFieldResolvers_textSelectResolver\n      }\n      ... on NumberCustomFieldDefinition {\n        ...buildCustomFieldResolvers_numberResolver\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_numberResolver on NumberCustomFieldDefinition {\n  __typename\n  name\n  token\n}\n\nfragment buildCustomFieldResolvers_textSelectResolver on TextSelectCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n  allowedValues {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_userResolver on UserCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n}\n"
  }
};
})();

(node as any).hash = "2d891aa7d4e9b5f25b31b4c31e6a19ef";

export default node;
